import posthog from 'posthog-js';

const posthogKey = process.env.REACT_APP_POSTHOG_KEY;
const posthogHost = process.env.REACT_APP_POSTHOG_HOST;

const isDevelopment = process.env.REACT_APP_ENV === 'development';

// PostHog is off in the development environment, so every capture guarded by
// this flag is skipped there.
export const isPostHogConfigured = !isDevelopment && Boolean(posthogKey && posthogHost);

export const initializePostHog = () => {
  if (!isPostHogConfigured) {
    if (!isDevelopment && process.env.NODE_ENV === 'development') {
      const missingVariable = posthogKey
        ? 'REACT_APP_POSTHOG_HOST'
        : 'REACT_APP_POSTHOG_KEY';
      throw new Error(
        `${missingVariable} variable required by PostHog is missing or un-configured, this causes events to be silently missed. This error stops appearing once ${missingVariable} is configured`
      );
    }

    return;
  }

  posthog.init(posthogKey, {
    api_host: posthogHost,
    defaults: '2026-05-30',
    logs: {
      serviceName: 'pet-web',
      environment: process.env.REACT_APP_ENV || process.env.NODE_ENV,
    },
    capture_exceptions: {
      capture_unhandled_errors: true,
      capture_unhandled_rejections: true,
      capture_console_errors: false,
    },
  });
};

export default posthog;
